import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from 'libs/shared/src/services/config/default.config';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the login/register component form.
 * Defines the fields to display for the form.
 */
export const REGISTER_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttonText',
      label: 'components.register.schema.buttonText',
      type: 'text',
      inputType: 'text',
      groupingName: 'components.register.schema.button',
      default: ''
    },
    {
      formControlName: 'buttons',
      label: 'components.register.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
